<template>
  <div>
    <view-table
        ref="vmTable"
        url="materialLabelPrints/page/image"
        :filter="filter"
        :limits="limits"
        :columns-property="columnsProperty"
        :table-select="false"
        module="basic"
        @reset="handleReset"
        @delete="handleDelete"
        @addOrEdit="handleAddOrEdit">
      <template #adSearch>
        <el-form :inline="true" :model="filter" @keyup.enter.native="getList(1)">
          <el-form-item label="文件名">
            <el-input v-model.trim="filter.fileName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="上传时间">
            <el-date-picker
                v-model="dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateChange"/>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
    <material-label-print-image-edit ref="editPage" @save-success="getList(-1)"/>
  </div>
</template>

<script>

  import ViewTable from "@/components/ViewTable.vue";
  import MaterialLabelPrintImageEdit from "@/views/MaterialLabel/MaterialLabelPrintImageEdit.vue";

  export default {
    name: "MaterialLabelPrintImageList",
    components: {MaterialLabelPrintImageEdit, ViewTable},
    data() {
      return {
        limits: {
          delAuth: this.$auth(756),
          addAuth: this.$auth(754),
          editAuth: this.$auth(755),
        },
        dateRange: [],
        filter: {
          fileName: "",
          startDate: "",
          endDate: "",
        },
        columnsProperty: [
          {
            key: "fileName",
            align: "center",
          },
          {
            key: "fileKey",
            align: "center",
            render: (h, params) => {
              return h(
                "el-image",
                {
                  style: {
                    width: "auto",
                    height: "50px",
                  },
                  props: {
                    fit: "contain",
                    src: params.row.filePath,
                    previewSrcList: [params.row.filePath],
                  },
                },
              );
            },
          },
          {
            key: "updateName",
            width: 110,
            align: "center",
          },
          {
            key: "updateTime",
            width: 160,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
          },
        ],
      };
    },
    mounted() {
      // this.getList(1);
    },
    methods: {
      getList(num) {
        this.$refs.vmTable.loadData(num);
      },
      dateChange(date) {
        if (date) {
          this.filter.startDate = date[0];
          this.filter.endDate = date[1];
        } else {
          this.filter.startDate = "";
          this.filter.endDate = "";
        }
      },
      handleReset(filter) {
        this.filter = Object.assign(this.filter, filter);
        this.dateRange = [];
      },
      handleAddOrEdit(row) {
        if (row) {
          this.$refs.editPage.open(row);
        } else {
          this.$refs.editPage.open();
        }
      },
      handleDelete(row) {
        this.$http.delete("basic","materialLabelPrints/image",row.id).then(() => {
          this.getList(-1);
          this.$message.success("删除成功");
        });
      },
    },
  };
</script>

<style scoped>

</style>
